/**
 * Coleta mensagens de erro em estruturas aninhadas retornadas pela API.
 */
function collectErrorMessages(value: any): string[] {
    if (!value) {
        return [];
    }

    if (typeof value === 'string') {
        const trimmed = value.trim();
        return trimmed ? [trimmed] : [];
    }

    if (Array.isArray(value)) {
        return value.reduce((messages: string[], item) => messages.concat(collectErrorMessages(item)), []);
    }

    if (typeof value === 'object') {
        let messages: string[] = [];

        if (Array.isArray(value.errors)) {
            messages = messages.concat(collectErrorMessages(value.errors));
        }

        if (value.children) {
            messages = messages.concat(collectErrorMessages(value.children));
        }

        Object.keys(value).forEach((key) => {
            if (key === 'errors' || key === 'children') {
                return;
            }

            messages = messages.concat(collectErrorMessages(value[key]));
        });

        return messages;
    }

    return [];
}

/**
 * Extrai a mensagem de erro mais útil do payload retornado pela API.
 */
export function extractMovimentacaoErrorMessage(error: any): string {
    if (!error) {
        return '';
    }

    if (typeof error.message === 'string' && error.message.trim()) {
        return error.message;
    }

    if (error.data) {

        const messages = collectErrorMessages(error.data.errors);
        if (messages.length) {
            return messages.join(' ');
        }

        if (typeof error.data.message === 'string' && error.data.message.trim()) {
            return error.data.message;
        }
    }

    return '';
}
